import type { Extension } from '@atlassian/jira-forge-ui-types/src/common/types/extension.tsx';

export const isExtensionVisible = (extension: Extension): boolean => !extension.hiddenBy;

export const isExtensionHidden = (extension: Extension): boolean => !!extension.hiddenBy;

export const isExtensionHiddenByAppAccessRules = (extension: Extension): boolean =>
	extension.hiddenBy === 'AppAccessRules';

export const isExtensionHiddenByDisplayConditions = (extension: Extension): boolean =>
	extension.hiddenBy === 'DisplayConditions';
